module.exports = __webpack_public_path__ + "static/media/featured-bg-shape.a703199e.svg";